import React, {useEffect, useState} from "react";
import { Identification } from "../../Identification";
import {PartiesLiee} from "./proceduresModal/partiesLiee/PartiesLiee";
import {PartiesLieeObservationGenerale} from "./proceduresModal/partiesLiee/PartieLieeObservationGenerale";
import {
    ajouterProcedurePartieLiee,
    getProcedurePartieLiee
} from "../../../../../data/procedureAudit";
import {getListeIdentificationSommaire} from "../../../../../data/rateau";
import swal from "sweetalert";
import {succesMessage} from "../../../../../helpers/AssetsHelpers";
import {faIdCard, faSave, faTasks} from "@fortawesome/free-solid-svg-icons";
import PageToolbarHeader from "../../../../modals/PageToolbarHeader";
import {StepBody, StepHeader} from "../../../../common/Step.components";
import ModalNavBarMenu from "../../../../modals/ModalNavBarMenu";
import {Button, Tooltip} from "antd";
import {appTheme} from "../../../../../config/theme";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import PrintConceptionControle from "../EE1/conceptionControle/PrintConceptionControle";
import PrintPartieLiee from "./proceduresModal/partiesLiee/PrintPartieLiee";

const ControlePartiesLiee = ({
         mission,
         client,
         code,
         // modalId,
         prev
     }) => {
    const [activeTab, setActiveTab] = useState(1);
    const [tache_id, setTache_id] = useState(null);
    const [user_id, setUser_id] = useState(null);
    const [codeSommaire] = useState(code || 'EE3.16');
    const [date, setDate] = useState('');
    const [heureEntree, setHeureEntree] = useState('');
    const [intervention_id, setIntervention_id] = useState(null);
    const [identifications, setIdentifications] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [loading, setLoading] = useState(false);
    const [selectYear, setSelectYear] = useState(mission.annee || "");
    const [missionSelected, setMissionSelected] = useState(mission || null);
    const [isProvisoire, setIsProvisoire] = useState('1');
    const [isTaskSave, setIsTaskSave] = useState([]);

    const [conclusion, setConclusion] = useState('')
    const [travauxData, setTravauxData] = useState([]);
    const [observation, setObservation] = useState('')
    const [isAddMemoire, setIsAddMemoire] = useState(false);
    const [excelPrintData, setExcelPrintData] = useState([]);

    useEffect(()=> {
        getProcedurePartieLiee(missionSelected.id)
            .then((res) => {
                if(res.result){
                    const noteFetch = res.result.codeSommaire === codeSommaire
                    if(noteFetch){
                        setObservation(res.result.observation)
                        setConclusion(res.result.conclusion)
                        setTravauxData(res.result?.Lea_ProcedurePartieLieeTravauxes);
                    }
                    else{
                        setObservation('')
                        setTravauxData([]);
                    }
                }
            })
    }, [codeSommaire, missionSelected])

    useEffect(()=> {
        if(activeTab === 0){
            getListeIdentificationSommaire(missionSelected.id, codeSommaire)
                .then((res) => {
                    setIdentifications(res.result)
                })
        }
    }, [activeTab, codeSommaire, missionSelected])

    useEffect(() => {
        if((travauxData ?? []).length > 0){
            const data = travauxData.map((item, index )=> ({
                index: index + 1,
                nature: item.libelle,
                reponse: item.reponse === '1' ? 'S/O': item.reponse === '2' ? 'OUI' : 'NON' ,
                commentaire: item.commentaire,
            }))
            setExcelPrintData(data)
        }
    }, [travauxData])

    const handleSubmit = async (e) => {
        e.preventDefault()

        const data = {
            intervention_id,
            date,
            heureEntree,
            tache_id,
            user_id,
            travauxData,
            conclusion,
            isAddMemoire,
            isProvisoire,
            observation,
            codeSommaire: codeSommaire,
            exercice_id: missionSelected.id,
            client_id: missionSelected.client_id
        }

        const {status, message} = await ajouterProcedurePartieLiee(data)
        if (status === 'success') {
            setLoading(false)
            await swal(succesMessage, '', 'success')
        } else {
            await swal(message, '', 'error')
            setLoading(false)
        }
    }

    const formSteps = [
        {
            code: "ID",
            title: "IDENTIFICATIONS",
            icon: faIdCard,
            content: (
                <Identification
                    identifications={identifications}
                    mission={missionSelected}
                />
            ),
        },
        {
            code: "PL",
            title: "Parties Liées",
            icon: faTasks,
            content: (
                <>
                    <PartiesLiee
                        client={client}
                        code={codeSommaire}
                        isProvisoire={isProvisoire}
                        setIsAddMemoire={setIsAddMemoire}
                        isAddMemoire={isAddMemoire}
                        setConclusion={setConclusion}
                        conclusion={conclusion}
                        selectItems={travauxData}
                        setSelectItems={setTravauxData}
                        chargement={loading}
                        mission={missionSelected}
                    />
                </>
            ),
        },
        {
            code: "OG",
            title: `Observation générale - ${selectYear}`,
            description: `Observation générale - ${selectYear}`,
            icon: faTasks,
            content: (
                <PartiesLieeObservationGenerale
                    observation={observation}
                    setObservation={setObservation}
                />
            ),
        },
    ];

    return (
        <>
            <div className="mx-5">
                <PageToolbarHeader
                    prev={prev} codeSommaire={codeSommaire}
                    pageTitle={"EE3.16 - Procédure d'audit complémentaire: Parties liées"}
                    mission={missionSelected}
                    setMission={setMissionSelected}
                    isProvisoire={isProvisoire}
                    setIsProvisoire={setIsProvisoire}
                    selectYear={selectYear}
                    setSelectYear={setSelectYear}
                    loading={loading}
                    setLoading={setLoading}
                    client={client}
                    setIsModalOpen={setIsModalOpen}
                    isModalOpen={isModalOpen}
                    setDate={setDate}
                    setTache_id={setTache_id}
                    tache_id={tache_id}
                    setIntervention_id={setIntervention_id}
                    intervention_id={intervention_id}
                    setHeureEntree={setHeureEntree}
                    setUser_id={setUser_id}
                    isTaskSave={isTaskSave}
                    isExcelPrint={true}
                    isLandingScape={true}
                    printTitle={(`EE3.16 - Procédure d'audit complémentaire: Parties liées ${selectYear}`)}
                    excelData={excelPrintData}
                    printContent={(
                        <PrintPartieLiee
                            datas={travauxData}
                            title={""}
                            conclusion={conclusion}
                            observation={observation}
                        />
                    )}
                />
                <StepHeader>
                    <ModalNavBarMenu
                        setActiveTab={setActiveTab}
                        activeTab={activeTab}
                        steps={formSteps}
                        setLoading={setLoading}
                        loading={loading}
                    />
                </StepHeader>
                <StepBody>
                    <>
                        <div className="d-flex justify-content-end align-items-end mb-10">
                            <Tooltip title="Enregistrer">
                                <Button
                                    disabled={(missionSelected.isCloture === 1 || missionSelected.isClotureProvisoire === 1)}
                                    size={"large"}
                                    // loading={loading}
                                    style={{
                                        backgroundColor: appTheme.colors.secondary,
                                        color: "white"
                                    }}
                                    icon={<FontAwesomeIcon style={{paddingRight: "10"}} icon={faSave}/>}
                                    onClick={handleSubmit}
                                >
                                    {!loading &&
                                        <span className='indicator-label text-white'>Enregistrer</span>}
                                    {loading && (
                                        <span className='indicator-progress fs-9 text-white'
                                              style={{display: 'block'}}>
                                  Patientez svp...
                                  <span
                                      className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                                    )}
                                </Button>
                            </Tooltip>
                        </div>
                        {formSteps[activeTab].content}
                    </>
                </StepBody>
            </div>
        </>
    );
}

export {ControlePartiesLiee}